import { Injectable } from '@angular/core';
import {
    AwbNotificationSubscriptionResponse,
    AWBSubscriptionService,
    SubscribeToAWBParams,
} from '@cargos/sprintpay-services';
import { Observable } from 'rxjs';

@Injectable()
export class SubscriptionAWBService {
    constructor(private awbSubscriptionService: AWBSubscriptionService) {}

    /**
     * Subscribe to an AWB to receive a notification once is ready
     */
    subscribeToAWB(body: SubscribeToAWBParams, locationId?: number): Observable<AwbNotificationSubscriptionResponse> {
        return this.awbSubscriptionService.subscribeToAWB(body, locationId);
    }

    cancelAutoPay(awb: string): Observable<string> {
        return this.awbSubscriptionService.cancelAutoPay(awb);
    }
}
